// extracted by mini-css-extract-plugin
export default {"compareMapsContainer":"CompareSegment_compareMapsContainer__O4H9e","seperator":"CompareSegment_seperator__YJ0li"};